import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserFindHelpersGameProps {
    onComplete: () => void;
}

interface PhaserFindHelpersGameState {
}

const gameConfig: GameConfig = {
    title: "Find Helpers Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserFindHelpersGame extends React.Component<PhaserFindHelpersGameProps, PhaserFindHelpersGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserFindHelpersGameProps) {
        super(props);
        bindAllOfThis(this, PhaserFindHelpersGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserFindHelpersGame;



// WEBPACK FOOTER //
// ./src/games/FindHelpersGame/Main.tsx